<template>
    <div class="col backgroundForm">
        <h4 class="col" align="center">REGISTRO DE DOCUMENTOS DE DESCARGO POR INGRESOS</h4>
        <div class="row">
            <button v-if="!d_finish" class="btn btn-block btn-success col-12 col-md-2 offset-md-1" @click="mModalDocument()">Añadir <font-awesome-icon icon="plus"></font-awesome-icon></button>
            <transition name="fade">
            <button v-if="d_finish" class="btn btn-block btn-danger col-12 col-md-2 offset-md-1" @click="mGoHome()">Inicio <font-awesome-icon icon="home"></font-awesome-icon></button>
            </transition>
            <transition name="fade">
                <button v-if="cStatusFinish" class="btn btn-block btn-warning col-12 col-md-2 offset-md-6" @click="mRegisterDischarge()" :disabled="f_disabled">Finalizar <font-awesome-icon icon="check"></font-awesome-icon></button>
            </transition>
        </div>
        <div class="col-12 offset-md-7 col-md-5" align="right">
            Descargo:<span class="badge badge-warning">{{ cTotalDebtsDocument }}</span> C. Cuenta:<span class="badge badge-dark">{{ cDebtsTotalDischarge }}</span> Diferencia:<span class="badge badge-info">{{ cDiferenceDischarge }}</span>
        </div>
        <br>
        <div class="table-responsive">
                <table class="table table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th>#</th>
                            <th scoped="col">Operacion</th>
                            <th scoped="col" class="d-none d-md-block">Detalle</th>
                            <th scoped="col">Documento</th>
                            <th scoped="col">Importe</th>
                            <th scoped="col">--</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(doc, ind) in cDocumentsDischarge" :key="doc.idDischarge">
                            <td><span class="badge badge-warning">{{ ind+1 }}</span></td>
                            <td>Descargo</td>
                            <td class="d-none d-md-block">{{ doc.chanelDescription }} {{ doc.documentDescription }}</td>
                            <td>{{ doc.documentNumber }}</td>
                            <td><span class="badge badge-warning">{{ doc.importe }}</span></td>
                            <td><button class="btn btn-sm btn-danger" @click="deleteDocument(doc.idDischarge)" :disabled="f_disabled"><font-awesome-icon icon="window-close"> </font-awesome-icon></button></td>
                        </tr>
                        <tr v-for="(debt, index) in cDebtsDischarge" :key="debt.idDownload">
                            <td><span class="badge badge-dark">{{ index+1 }}</span></td>
                            <td>C. Cuenta</td>
                            <td class="d-none d-md-block">{{ debt.responsability }}</td>
                            <td>{{ debt.operation }} {{ debt.correlative }}/{{ debt.anio }}</td>
                            <td><span class="badge badge-dark">{{ debt.total }} </span></td>
                            <td><button class="btn btn-sm btn-success" disabled><font-awesome-icon icon="check"> </font-awesome-icon></button></td>
                        </tr>
                    </tbody>
                </table>
        </div>
        <modal-document :id-modal="idModal" :view-modal="viewModal" :types-document="dtDocuments" :types-chanel="dtChanels"></modal-document>
        <modal-loading :id-modal="modal_progress" :title="d_title" :status-send="send_discharge" ></modal-loading>
        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
    </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue';
const qs= require('qs');
import modalDocument from './ModalDocument'
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';

export default {
    name:'send-discharge',
    data(){
        return {
            typeDocuments:[],
            viewModal:true,
            idModal:'otherDocument',
            dtDocuments:[],
            dtChanels:[],
            difDischarge:null,
            modal_progress:'loadingDischarge',
            d_title:'Enviando Informacion',
            send_discharge:true,
            modal_report:'dischargeSend',
            modal_rep_title:'Solicitud Descargo',
            modal_rep_content:'',
            url_report:'pdfDischarge',
            id_reporte:0,
            f_disabled:false,
            d_finish:false
        }
    },
    created:function(){
        return parseFloat(this.cDebtsTotalDischarge)===0 ? this.$router.push('discharge'):true;
    },
    mounted(){
        this.callTypesDocument();
    },
    methods:{
        async callTypesDocument(){
            // let tdocumnts=await axios.get('getDocuments/document?api_token='+Vue.auth.getToken());
            // let tchanels=await axios.get('getChanels?api_token='+Vue.auth.getToken());
            // let tdocumnts=await axios.get(`getDocuments/document`);
            // let tchanels=await axios.get(`getChanels`);
            let tdocumnts=await axios.get(`getDocuments/document?api_token=${Vue.auth.getToken()}`);
            let tchanels=await axios.get(`getChanels?api_token=${Vue.auth.getToken()}`);
            this.dtDocuments=tdocumnts.data;
            this.dtChanels=tchanels.data;
        },
        mModalDocument(){
            $('#'+this.idModal).modal('show');
        },
        deleteDocument(id){
            this.$store.dispatch('sDocDebts/deleteDocument', id);
        },
        mRegisterDischarge(){
            // console.log(this.cDocumentsDischarge.length)
            // console.log(this.cDebtsDischarge.length)

            const master={
                port:null,
                import:null,
                module:null,
                user:null
            };
            const detail=[];
            let auxDetail;
            this.cDebtsDischarge.forEach( (item, index) => {
                
                let auxChanel;

                master.port=item.port;
                master.import+=item.total;
                master.module=item.module;
                master.user=this.cUserSession.nick;

                switch(item.module){
                    case 'oper':
                        auxChanel=3;
                    break;
                    case 'enroll':
                        auxChanel=1;
                    break;
                    case 'renew':
                        auxChanel=2;
                    break;
                    case 'penalty':
                        auxChanel=4;
                        break;
                }

                auxDetail={
                    chanel:parseInt(auxChanel),
                    item:(index+1),
                    assignLoad:'S',
                    idOperation:item.idDownload,
                    import:item.total,
                    typeDocument:288,
                    numberDoc: (item.correlative+'/'+item.anio),
                    type_operation: item.operation,
                    dateDoc:item.dateDoc
                }
                detail.push(auxDetail);
            });

            this.cDocumentsDischarge.forEach( (item, index) =>{
                auxDetail={
                    chanel:item.chanelId,
                    item:(detail.length+1),
                    assignLoad:'N',
                    idOperation:0,
                    import:(item.importe* (-1)),
                    typeDocument:item.documentId,
                    numberDoc: item.documentNumber,
                    type_operation:'DEPOSITO',
                    dateDoc:item.documentDate
                }
                detail.push(auxDetail);
            });
            // console.log(master);
            // console.log(detail);
            const param={
                dHead:JSON.stringify(master),
                dBody:JSON.stringify(detail)
            }
            this.mProgressModal();
            // axios.post(`insertDocuments/${master.module}`, 
            axios.post(`insertDocuments/${master.module}?api_token=${Vue.auth.getToken()}`, 
                    qs.stringify(param))
                    .then(res=>{
                        setTimeout(()=>{
                            this.f_disabled=true;
                            this.mCloseProgressModal();
                            // console.log(res.data[0].respuesta)
                            this.modal_rep_content=res.data[0].respuesta;
                            this.id_reporte=res.data[1].id_rep;
                            this.mModalReportShow();
                            this.d_finish=true;
                        }, 2000)
                    }).catch(err=>{
                        console.log(err);
                    })
        },
        mProgressModal(){
            $('#'+this.modal_progress).modal('show');
        },
        mCloseProgressModal(){
            $('#'+this.modal_progress).modal('hide');
        },
        mModalReportShow(){
            $('#'+this.modal_report).modal('show');
        },
        mGoHome(){
            this.$router.push('discharge');
        }
    },    
    computed:{
        cDebtsTotalDischarge(){
            return this.$store.getters['sDebtsP/getDebtsTotal'];
        },
        cDebtsDischarge(){
            return this.$store.getters['sDebtsP/getDebtsPending'];
        },
        cDocumentsDischarge(){
            return this.$store.getters['sDocDebts/getDocumentsDebts'];
        },
        cTotalDebtsDocument(){
            return this.$store.getters['sDocDebts/getDocumentDebtT'];
        },
        cDiferenceDischarge(){
            return (this.cDebtsTotalDischarge - this.cTotalDebtsDocument).toFixed(2);
        },
        cStatusFinish(){
            return parseFloat(this.cDiferenceDischarge) === 0 ? true:false;
        },
        cUserSession(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-document':modalDocument,
        'modal-loading':modalLoading,
        'modal-report':modalReport
    }
}
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/components/finanzas/SendDischarge.vue